import styled from 'styled-components';

import SubNav from '~/views/components/subNav/SubNav';

// TODO use breakpoints in breakaway, but need to make sure everything looks correct
const OLD_BREAKPOINTS = {
    PHONE_ONLY: '@media (max-width: 599px)',
    TABLET_PORTRAIT: '@media (min-width: 600px)',
    TABLET_LANDSCAPE: '@media (min-width: 900px)',
    DESKTOP: '@media (min-width: 1310px)',
};

export const RecordContainer = styled.div`
    flex-direction: column;
    margin-bottom: 40px;

    h2 {
        padding: 10px 10px 0;

        ${OLD_BREAKPOINTS.DESKTOP} {
            padding: 10px 20px 0;
        }
    }

    .records-wrapper {
        margin-top: 0;

        ${OLD_BREAKPOINTS.TABLET_PORTRAIT} {
            margin: 0 10px 10px;
        }

        ${OLD_BREAKPOINTS.DESKTOP} {
            margin: 0 20px 20px;
        }
    }

    .records-column {
        display: flex;
        flex-direction: column;
        flex: 1;
    }
`;

export const RecordTableContainer = styled.div`
    padding: 10px;
    border: 1px solid transparent;

    ${OLD_BREAKPOINTS.DESKTOP} {
        padding: 20px;
    }

    h3,
    h4 {
        margin-bottom: 10px;
        display: block;
    }

    a {
        margin-top: 10px;
    }

    .records-table {
        margin-bottom: 10px;

        tr {
            td {
                width: 50%;
                text-align: left;

                &:first-child {
                    ${OLD_BREAKPOINTS.TABLET_PORTRAIT} {
                        width: 380px;
                    }
                }
            }
        }
    }
`;

export const SubNavContainer = styled(SubNav)`
    margin: 20px 0;
`;
